<ng-container *ngIf="'gridRegistration.meteringConceptSelectionHint' | uiAdaptionVisible$ | async">
  <app-hint-card [outlined]="true" [type]="'info'">
    <div [innerHTML]="'gridRegistration.meteringConceptSelectionHint' | uiAdaptionValue"></div>
  </app-hint-card>
</ng-container>
<app-display-and-select-option
  [columns]="3"
  [article]="'ein'"
  [title]="'Messkonzept'"
  [canUpdate]="canUpdate$ | async"
  [disable]="disable"
  [options]="options$ | async"
  [selectedOption]="selectedOption$ | async"
  (onSelectedOptionChanged)="onSelectedOptionChanged($event)"></app-display-and-select-option>
